import React from 'react';

interface FolderBreadcrumbsProps {
  caseFolder: string
  selectedSubFolder: string;
  onSelectSubFolder: (subFolder: string) => void;
  onSelectCaseFolder: () => void;
}

const FolderBreadcrumbs: React.FC<FolderBreadcrumbsProps> = 
  ({ caseFolder, selectedSubFolder, onSelectSubFolder, onSelectCaseFolder }) => {

    // Build breadcrumb segments from selectedSubFolder
    const segments = selectedSubFolder
      ? selectedSubFolder.split('/').filter(Boolean)
      : [];

    // Helper to build cumulative path for a segment index
    const cumulativePath = (idx: number): string =>
      segments.slice(0, idx + 1).join('/');

    return (
      <nav
        data-testid="folder-contents-header"
        aria-label="Breadcrumb"
        className="mb-4 text-sm"
      >
        <ol className="flex items-center flex-wrap gap-1 text-gray-600">
          <li>
            <button
              type="button"
              onClick={onSelectCaseFolder}
              className="text-blue-600 hover:underline focus:outline-none focus:ring-2 focus:ring-blue-400 rounded-sm"
            >
              Case Folders
            </button>
          </li>
          <li className="select-none text-gray-400">/</li>

          <li className="font-semibold text-gray-900" data-testid="breadcrumb-case-folder">
            {segments.length > 0 ? (
              <button
                type="button"
                onClick={() => onSelectSubFolder('')}
                className="text-blue-600 hover:underline focus:outline-none focus:ring-2 focus:ring-blue-400 rounded-sm font-semibold"
                title="Back to case root"
              >
                {caseFolder}
              </button>
            ) : (
              <span aria-current="page">{caseFolder}</span>
            )}
          </li>

          {segments.map((segment, idx) => (
            <React.Fragment key={idx}>
              <li className="select-none text-gray-400">/</li>
              <li
                className="font-semibold text-gray-900"
                data-testid={`breadcrumb-segment-${idx}`}
              >
                {idx < segments.length - 1 ? (
                  <button
                    type="button"
                    onClick={() => onSelectSubFolder(cumulativePath(idx))}
                    className="text-blue-600 hover:underline focus:outline-none focus:ring-2 focus:ring-blue-400 rounded-sm"
                    title={`Go to ${segment}`}
                  >
                    {segment}
                  </button>
                ) : (
                  <span aria-current="page">{segment}</span>
                )}
              </li>
            </React.Fragment>
          ))}
        </ol>
      </nav>
    );
  };
export default FolderBreadcrumbs;
